module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-gatsby-cloud/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-instagram-embed/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"panmacmillan.co.in","short_name":"panmacmillan.co.in","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"minimal-ui","icon":"src/pm_framework/assets/images/HHIcon-yellow.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"34bf0904f0510d8b2048b9ace94b269c"},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-WFWQNH5Q","includeInDevelopment":false,"defaultDataLayer":{"type":"object","value":{"platform":"gatsby"}},"enableWebVitalsTracking":true,"gtmAuth":"PMxRpVEjoBHdzgKjsNTjYQ","gtmPreview":"env-1","routeChangeEventName":"gatsby-route-change","selfHostedOrigin":"https://www.googletagmanager.com","selfHostedPath":"gtm.js"},
    },{
      plugin: require('../node_modules/gatsby-plugin-twitter/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../plugins/@panmacmillan/gatsby-theme-panmacmillan/gatsby-browser.js'),
      options: {"plugins":[],"kontentProjectId":"2f72e3e0-0212-011d-7a37-eda0bb70522e","displayArticleFooterEmailSignUp":true,"disableArticlesBooksYouMayLike":true,"displayOneTrustFooterButton":false,"footerCopyrightLine":"&copy; Harriman House 2025"},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
